<template>
  <div :class="companyCfClass">
      <span v-if="label" class="label text-right" :class="labelClass">
        {{ label }}
      </span>

    <div class="col-10">
      <div class="label col-12 pb-3" v-for="(content, index) in value" v-if="content && index !== 'id'" :class="noneContent(index)">
         <span  class="label title" :class="titleClass">
          {{ titleObject(index) }}
        </span>

        <div v-if="index !== 'id'" class="value col-10 d-inline-block" :class="valueClass">
          {{ content }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    id: Number,
    value: {
      type: Object
    },
    label: String,
    title: String,
    width: String
  },

  methods: {

    titleObject (index) {
      this.title = '_' + index
      return this.$t(this.title)
    },

    noneContent (index) {
      if (index === 'id') {
        return 'd-none'
      }
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    }
  },

  computed: {
    companyCfClass: function () {
      if (this.value) {
        return 'field companycf'
      }
      return 'd-none'
    },

    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    }
  }
}
</script>

<style scoped>

</style>
